import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-3 border-b py-4 md:grid md:grid-cols-[minmax(0,1fr)_minmax(10rem,14rem)_auto] md:gap-6 md:items-start" }
const _hoisted_2 = { class: "flex items-start justify-between gap-2" }
const _hoisted_3 = { class: "flex items-center min-w-0 flex-wrap" }
const _hoisted_4 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_5 = { class: "md:hidden shrink-0" }
const _hoisted_6 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_7 = { class: "mt-2 min-w-0" }
const _hoisted_8 = {
  key: 0,
  class: "mt-2 min-w-0"
}
const _hoisted_9 = { class: "flex flex-wrap gap-2" }
const _hoisted_10 = ["checked", "disabled"]
const _hoisted_11 = ["checked", "disabled"]
const _hoisted_12 = ["checked", "disabled"]
const _hoisted_13 = { class: "hidden md:block" }

import { ChatBubbleLeftRightIcon, DevicePhoneMobileIcon, EnvelopeIcon } from '@heroicons/vue/24/outline'
import { computed } from 'vue'

import BasicBadge from '@/components/BasicBadge'
import NeueToggle from '@/components/neue/NeueToggle'
import NotificationEmailsPopover from '@/components/settings/NotificationEmailsPopover'


export default {
  __name: 'NotificationRow',
  props: {
  notification: {
    type: Object,
    required: true
  },
  currentUserEmail: {
    type: String,
    required: true
  },
  canEditEmails: {
    type: Boolean,
    default: false
  }
},
  emits: ['update', 'request-push-permission', 'disable-push'],
  setup(__props, { emit: __emit }) {

const LABELS = {
  NewOrderNotification: 'New order',
  InboundSmsNotification: 'Inbound SMS',
  NewSignupNotification: 'New signup',
  CustomerReceiptNotification: 'Customer receipt',
  DropReminderNotification: 'Drop reminder alerts'
}

const DESCRIPTIONS = {
  NewOrderNotification: 'A customer places an order for your store',
  InboundSmsNotification: 'A customer sends you a text message',
  NewSignupNotification: 'A new customer creates an account',
  CustomerReceiptNotification: 'A purchase receipt is delivered to a customer',
  DropReminderNotification: 'When a drop reminder is at risk of not sending, or did not send'
}

const SMS_CAPABLE_TYPES = ['NewOrderNotification', 'DropReminderNotification']

const props = __props

const emit = __emit

const label = computed(() => LABELS[props.notification.attributes.type] || props.notification.attributes.type)
const description = computed(() => DESCRIPTIONS[props.notification.attributes.type] || '')
const emailChannelOn = computed(() => (props.notification.attributes.email || '').trim().length > 0)
const supportsSms = computed(() => SMS_CAPABLE_TYPES.includes(props.notification.attributes.type))
const smsChannelOn = computed(() => props.notification.attributes.sms_enabled === true)
const smsPhone = computed(() => props.notification.attributes.sms_phone || '')

function emailListArr() {
  return (props.notification.attributes.email || '')
    .split(',')
    .map(e => e.trim())
    .filter(Boolean)
}

function onMasterToggle(newValue) {
  if (newValue) {
    const list = emailListArr()
    if (!list.includes(props.currentUserEmail)) list.push(props.currentUserEmail)
    emit('update', { is_active: true, email: list.join(',') })
  } else {
    emit('update', { is_active: false })
  }
}

function onEmailChannelToggle(checked) {
  if (checked) {
    const list = emailListArr()
    if (!list.includes(props.currentUserEmail)) list.push(props.currentUserEmail)
    emit('update', { email: list.join(',') })
  } else {
    emit('update', { email: '' })
  }
}

function onPushChannelToggle(checked) {
  if (checked) {
    emit('request-push-permission')
    emit('update', { web_push_enabled: true })
  } else {
    emit('disable-push')
    emit('update', { web_push_enabled: false })
  }
}

function onSmsChannelToggle(checked) {
  if (checked) {
    emit('update', { sms_enabled: true })
  } else {
    emit('update', { sms_enabled: false })
  }
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["min-w-0", { 'opacity-50': !__props.notification.attributes.is_active }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(label.value), 1),
          (__props.notification.attributes.is_active)
            ? (_openBlock(), _createBlock(_unref(BasicBadge), {
                key: 0,
                name: "ACTIVE",
                props: { hasSuccess: true }
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(NeueToggle), {
            "model-value": __props.notification.attributes.is_active,
            compact: "",
            onChange: onMasterToggle
          }, null, 8, ["model-value"])
        ])
      ]),
      _createElementVNode("p", _hoisted_6, _toDisplayString(description.value), 1),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(NotificationEmailsPopover), {
          emails: __props.notification.attributes.email || '',
          "can-edit": __props.canEditEmails,
          onUpdate: _cache[0] || (_cache[0] = $event => (emit('update', { email: $event })))
        }, null, 8, ["emails", "can-edit"])
      ]),
      (supportsSms.value && smsChannelOn.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_unref(NotificationEmailsPopover), {
              kind: "phone",
              emails: smsPhone.value,
              "can-edit": __props.canEditEmails,
              onUpdate: _cache[1] || (_cache[1] = $event => (emit('update', { sms_phone: $event })))
            }, null, 8, ["emails", "can-edit"])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["min-w-0", { 'opacity-50': !__props.notification.attributes.is_active }])
    }, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", {
          class: _normalizeClass(["inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-sm cursor-pointer select-none", 
            emailChannelOn.value
              ? 'border-green-600 bg-green-50 text-green-700'
              : 'border-gray-300 bg-white text-gray-600 hover:bg-gray-50'
          ])
        }, [
          _createElementVNode("input", {
            type: "checkbox",
            class: "sr-only",
            checked: emailChannelOn.value,
            disabled: !__props.notification.attributes.is_active,
            onChange: _cache[2] || (_cache[2] = $event => (onEmailChannelToggle($event.target.checked)))
          }, null, 40, _hoisted_10),
          _createVNode(_unref(EnvelopeIcon), { class: "h-4 w-4 shrink-0" }),
          _cache[5] || (_cache[5] = _createElementVNode("span", null, "Email", -1))
        ], 2),
        (__props.notification.attributes.type === 'InboundSmsNotification')
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              class: _normalizeClass(["inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-sm cursor-pointer select-none", 
            __props.notification.attributes.web_push_enabled
              ? 'border-green-600 bg-green-50 text-green-700'
              : 'border-gray-300 bg-white text-gray-600 hover:bg-gray-50'
          ])
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                class: "sr-only",
                checked: __props.notification.attributes.web_push_enabled,
                disabled: !__props.notification.attributes.is_active,
                onChange: _cache[3] || (_cache[3] = $event => (onPushChannelToggle($event.target.checked)))
              }, null, 40, _hoisted_11),
              _createVNode(_unref(DevicePhoneMobileIcon), { class: "h-4 w-4 shrink-0" }),
              _cache[6] || (_cache[6] = _createElementVNode("span", null, "Push", -1))
            ], 2))
          : _createCommentVNode("", true),
        (supportsSms.value)
          ? (_openBlock(), _createElementBlock("label", {
              key: 1,
              class: _normalizeClass(["inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-sm cursor-pointer select-none", 
            smsChannelOn.value
              ? 'border-green-600 bg-green-50 text-green-700'
              : 'border-gray-300 bg-white text-gray-600 hover:bg-gray-50'
          ])
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                class: "sr-only",
                checked: smsChannelOn.value,
                disabled: !__props.notification.attributes.is_active,
                onChange: _cache[4] || (_cache[4] = $event => (onSmsChannelToggle($event.target.checked)))
              }, null, 40, _hoisted_12),
              _createVNode(_unref(ChatBubbleLeftRightIcon), { class: "h-4 w-4 shrink-0" }),
              _cache[7] || (_cache[7] = _createElementVNode("span", null, "SMS", -1))
            ], 2))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_unref(NeueToggle), {
        "model-value": __props.notification.attributes.is_active,
        compact: "",
        onChange: onMasterToggle
      }, null, 8, ["model-value"])
    ])
  ]))
}
}

}